import axios from "axios";
import { environment } from "../../environments/environment";

export interface Postcode {
    cep: string,
    logradouro: string,
    complemento: string,
    bairro: string,
    localidade: string,
    uf: string,
    ibge: string,
    city_id: number
}

export const retrievePostcodeInfo = async (postcode: string) => {
    const response = await axios.get<Postcode>(environment.apiUrl+'/api/cep/'+postcode);

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
}